import './PardotEmailMetadataTab.scss';
import { convertISODateToPardotDate } from '@sonar-software/sonar-ts-lib';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PardotEmailTemplate } from '@periscopes/general/email-templates';
import { SonarText } from '@ui/text';
import { COPY_SONAR_OBJECT_BASE, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { MetadataContainer } from '@periscopes/general/metadata';
import { PeriscopePardotEmailState, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useMemo } from 'react';
import { usePeriscopeActions, usePeriscopeMetadata } from '@hooks';
function getStateAndDateMetadataEntries(metadata) {
    switch (metadata.state) {
        case PeriscopePardotEmailState.Scheduled:
            return [
                {
                    bold: true,
                    label: COPY_SPECIFIC.STATE,
                    type: 'string',
                    value: metadata.state
                },
                {
                    label: COPY_SPECIFIC.SCHEDULED_FOR,
                    type: 'string',
                    value: metadata.scheduledFor ? convertISODateToPardotDate(metadata.scheduledFor) : null
                }
            ];
        case PeriscopePardotEmailState.Sent:
            return [
                {
                    bold: true,
                    label: COPY_SPECIFIC.STATE,
                    type: 'string',
                    value: metadata.state
                },
                {
                    label: COPY_SPECIFIC.SENT_AT,
                    type: 'string',
                    value: metadata.scheduledFor ? convertISODateToPardotDate(metadata.scheduledFor) : null
                }
            ];
        default:
            return [
                {
                    bold: true,
                    label: COPY_SPECIFIC.STATE,
                    type: 'string',
                    value: metadata.state
                }
            ];
    }
}
export const PardotEmailMetadataTab = ({ index, sonarObjectId }) => {
    const { openPeriscope } = usePeriscopeActions();
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.PardotEmail);
    const handleEmailTemplateClick = useCallback(() => {
        var _a, _b;
        if (!((_a = metadata === null || metadata === void 0 ? void 0 : metadata.emailTemplate) === null || _a === void 0 ? void 0 : _a.sonarObjectId)) {
            return;
        }
        const { emailTemplate } = metadata;
        openPeriscope({
            id: emailTemplate.sonarObjectId,
            name: emailTemplate.displayName,
            openedFromIndex: index,
            type: (_b = emailTemplate.sonarObjectType) !== null && _b !== void 0 ? _b : SonarObjectType.PardotEmailTemplate
        });
    }, [index, openPeriscope, metadata]);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const stateAndDateMetadataEntries = getStateAndDateMetadataEntries(metadata);
        const entries = [
            ...stateAndDateMetadataEntries,
            {
                label: COPY_SPECIFIC.SENDER,
                type: 'array',
                value: metadata.sender
            },
            {
                label: COPY_SPECIFIC.REPLY_TO,
                type: 'array',
                value: metadata.replyTo
            },
            {
                label: COPY_SPECIFIC.TYPE,
                type: 'string',
                value: metadata.type
            },
            {
                label: COPY_SPECIFIC.CONTENT_TYPE,
                type: 'string',
                value: metadata.contentType
            },
            {
                label: COPY_SPECIFIC.SUBJECT,
                type: 'string',
                value: metadata.subject
            },
            {
                label: COPY_SPECIFIC.BOUNCE,
                type: 'string',
                value: metadata.bounce
            }
        ];
        return entries;
    }, [metadata]);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.EMAIL_INFORMATION }),
        (metadata === null || metadata === void 0 ? void 0 : metadata.emailTemplate) &&
            React.createElement(React.Fragment, null,
                React.createElement(SonarText, { className: 'email-template-title' }, COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE),
                React.createElement(PardotEmailTemplate, { entity: metadata.emailTemplate, onEmailTemplateClick: handleEmailTemplateClick }))));
};
